module.exports = __webpack_public_path__ + "images/thumbs-down-fill09c1d1f190568a7ed0dcb28806ba1c93.svg";